/* eslint-disable no-unused-vars */
import { Col, Row, Spin } from "antd";
import Button from "@ui/form-controls/button";
import { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { useDidMountEffect } from "@app/shared/hooks/useDidMountEffect";

import { getGlobalSearch } from "@redux/actionCreators/candidateModal";

import Loader from "@ui/feedback/loader";
import CandidateTableMessageModal from "@app/features/candidate-management/ui/candidate-management/candidate-table-message-modal";
import {
  SEND_MESSAGE_TAB,
  SMS_HISTORY_TAB,
  TEMPLATE_TAB
} from "@ui/messaging/send-message-modal";
import { Search } from "@ui/form-controls/search";
import GlobalFilter from "./global-filter";
import PersonList from "./person-list";

const MESSAGE_TAB_ORDER = [SEND_MESSAGE_TAB, TEMPLATE_TAB, SMS_HISTORY_TAB];

const GlobalSearch = ({ searchString }) => {
  const dispatch = useDispatch();

  const [sendSmsAndAppMessageModal, setSendSmsAndAppMessageModal] = useState(false);
  const [searchValue, setSearchValue] = useState(searchString || "");
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [tableData, setTableData] = useState([]);

  const candidateModalReducer = useSelector(rdc => rdc?.candidateModalReducer, shallowEqual);

  const {
    getGlobalSearch: { resultData: globalSearchData = "", isLoading: globalSearchLoading }
  } = candidateModalReducer;

  const sendRecipients = useMemo(() => {
    const people = globalSearchData?.Person || [];
    return selectedIds.map(id => {
      const person = people.find(item => item.ObjectId === id);
      return {
        objectId: id,
        name: person?.Name || "",
        candidateObjectId: person?.CandidateList?.[0]?.ObjectId
      };
    });
  }, [selectedIds, globalSearchData]);

  const handleFilterData = data => {
    setFilterData(data);
  };

  const handleSearch = data => {
    if (data) {
      dispatch(getGlobalSearch(data));
      setSearchValue(data);
    } else {
      setTableData([]);
    }
  };

  const checkedForMsg = (e, item) => {
    const checkedValue = e.target?.checked;
    if (checkedValue) {
      setSelectedIds(previousFiles => [...previousFiles, item.ObjectId]);
    } else {
      const filteredValues = selectedIds.filter(data => data !== item.ObjectId);
      setSelectedIds(filteredValues);
    }
  };

  // set table data after global search request
  useEffect(() => {
    if (globalSearchData) {
      setTableData(globalSearchData);
    }
  }, [globalSearchData]);

  // handle filter data changes
  useDidMountEffect(() => {
    if (filterData) {
      const selectedData = globalSearchData || {};

      const filteredByValue = Object.fromEntries(
        Object.entries(filterData).filter(([key, value]) => value === true)
      );

      const filteredTable = Object.fromEntries(
        Object.entries(selectedData).filter(([key, value]) => key in filteredByValue)
      );

      setTableData(filteredTable);
    }
  }, [filterData]);

  return (
    <div className="global-search">
      <Spin
        indicator={<Loader />}
        spinning={globalSearchLoading}
        className="loaderGifPosition"
      >
        {sendSmsAndAppMessageModal && (
          <CandidateTableMessageModal
            recipients={sendRecipients}
            onClose={() => setSendSmsAndAppMessageModal(false)}
            onSent={() => setSelectedIds([])}
            defaultTab={SEND_MESSAGE_TAB}
            tabOrder={MESSAGE_TAB_ORDER}
          />
        )}

        <Row>
          <Col span={6}>
            <GlobalFilter
              searchString={searchValue}
              handleFilterData={handleFilterData}
              tableData={tableData}
            />
          </Col>

          <Col span={17} style={{ marginLeft: "10px" }} className="result-list">
            {/* search input and send msg button */}
            <Row gutter={16}>
              <Col span={21}>
                <Search onSearch={e => handleSearch(e)} defaultValue={searchValue} />
              </Col>

              <Col span={3}>
                <Button
                  variant="primary"
                  disabled={selectedIds.length === 0}
                  onClick={() => setSendSmsAndAppMessageModal(true)}
                >
                  Send Message
                </Button>
              </Col>
            </Row>

            <PersonList data={tableData} selectedIds={selectedIds} checkedForMsg={checkedForMsg} />
          </Col>
        </Row>
      </Spin>
    </div>
  );
};
export default GlobalSearch;
